module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "Reset-content"
  }, [_c('div', {
    staticClass: "Reset-content-title"
  }, [_c('ul', {
    staticClass: "clearfix"
  }, [_c('li', {
    staticClass: "active"
  }, [_vm._v("\n\t\t\t\t\t安全验证\n\t\t\t\t")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("\n\t\t\t\t\t重置密码\n\t\t\t\t")]), _vm._v(" "), (_vm.query.status == 200) ? _c('li', {
    staticClass: "active"
  }, [_vm._v("\n\t\t\t\t\t修改成功\n\t\t\t\t")]) : _c('li', {
    staticClass: "active"
  }, [_vm._v("\n\t\t\t\t\t修改失败\n\t\t\t\t")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.query.status == 200) ? _c('div', {
    staticClass: "Reset-content-tab"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/user/Success.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("恭喜您 密码重置成功！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.index) + "秒后自动跳转到首页，若未跳转，可"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Jump
    }
  }, [_vm._v("点击跳转")])])]) : _c('div', {
    staticClass: "Reset-content-tab"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/user/error.png")
    }
  }), _vm._v(" "), _c('h3', [_vm._v("很遗憾 密码重置失败！")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.index) + "秒后自动跳转到首页，若未跳转，可"), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.Jump
    }
  }, [_vm._v("点击跳转")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line"
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d5ec345"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/ResetResult.vue
// module id = 762
// module chunks = 1